// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"GAFBf":[function(require,module,exports,__globalThis) {
function initializeFaqAccordion(root) {
    // Delegated on root rather than attaching a listener per item found at
    // init time: querySelectorAll returns a static snapshot, and the editor
    // canvas can re-render items inside an already-initialized root (ACF
    // updates the preview in place on field changes without necessarily
    // replacing the root node) — a one-time snapshot would leave newly added
    // items with no click handler and keep referencing removed ones.
    root.addEventListener('click', function(event) {
        var question = event.target.closest('.faq__question');
        if (!question) return;
        var item = question.closest('.faq__item');
        var answer = item ? item.querySelector('.faq__answer') : null;
        if (!item || !answer) return;
        var isOpen = item.classList.contains('faq__item--open');
        // Close all other FAQ items. Queried fresh on every click, scoped to
        // this block's own document (the frontend page, or the editor canvas
        // iframe) via root.ownerDocument, matching the original single-document
        // behavior while staying correct inside the iframe realm.
        root.ownerDocument.querySelectorAll('.faq__item').forEach(function(otherItem) {
            if (otherItem !== item) {
                otherItem.classList.remove('faq__item--open');
                var otherQuestion = otherItem.querySelector('.faq__question');
                var otherAnswer = otherItem.querySelector('.faq__answer');
                if (otherQuestion) otherQuestion.setAttribute('aria-expanded', 'false');
                if (otherAnswer) otherAnswer.style.maxHeight = null;
            }
        });
        // Toggle current item
        if (isOpen) {
            item.classList.remove('faq__item--open');
            question.setAttribute('aria-expanded', 'false');
            answer.style.maxHeight = null;
        } else {
            item.classList.add('faq__item--open');
            question.setAttribute('aria-expanded', 'true');
            answer.style.maxHeight = "".concat(answer.scrollHeight, "px");
        }
    });
}
function initializeFaqPopups(doc) {
    if (doc.__faqPopupsInitialized) return;
    doc.__faqPopupsInitialized = true;
    // Delegated on the document rather than per-element listeners found at
    // init time, for the same reason as the accordion above: triggers/popups
    // can be added or replaced later by the editor's re-renders. Trigger and
    // closer matches are checked before any generic "clicked inside content"
    // fallback so a closer nested inside .faq-popup__content (see faq.twig:
    // .faq-popup__close lives inside .faq-popup__content) still closes the
    // popup — a click elsewhere inside the content that matches neither is
    // simply a no-op, which is what the original per-element
    // stopPropagation() on .faq-popup__content amounted to in practice.
    doc.addEventListener('click', function(e) {
        var trigger = e.target.closest('[data-popup-trigger]');
        if (trigger) {
            e.preventDefault();
            var popupId = trigger.getAttribute('data-popup-trigger');
            var popup = doc.getElementById(popupId);
            if (popup) {
                popup.classList.add('faq-popup--visible');
                popup.setAttribute('aria-hidden', 'false');
                doc.body.classList.add('popup-open');
                // Focus trap
                var focusableElements = popup.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                if (focusableElements.length > 0) focusableElements[0].focus();
            }
            return;
        }
        var closer = e.target.closest('.faq-popup__close, .faq-popup__overlay');
        if (closer) {
            var popup1 = closer.closest('.faq-popup');
            if (popup1) {
                popup1.classList.remove('faq-popup--visible');
                popup1.setAttribute('aria-hidden', 'true');
                doc.body.classList.remove('popup-open');
            }
        }
    });
    // Close popup on ESC key
    doc.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            var visiblePopup = doc.querySelector('.faq-popup--visible');
            if (visiblePopup) {
                visiblePopup.classList.remove('faq-popup--visible');
                visiblePopup.setAttribute('aria-hidden', 'true');
                doc.body.classList.remove('popup-open');
            }
        }
    });
}
function initializeFaqBlock(root) {
    if (!root || root.dataset.faqInitialized === 'true') return;
    var faqItems = root.querySelectorAll('.faq__item');
    if (!faqItems.length) return;
    root.dataset.faqInitialized = 'true';
    initializeFaqAccordion(root);
    initializeFaqPopups(root.ownerDocument);
}
function initializeFrontend() {
    document.querySelectorAll('.faq').forEach(initializeFaqBlock);
}
if (window.acf) window.acf.addAction('render_block_preview/type=faq', function($block) {
    initializeFaqBlock($block.get(0));
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeFrontend);
else initializeFrontend();

},{}]},["GAFBf"], "GAFBf", "parcelRequire8c83", {})

//# sourceMappingURL=script.js.map
